import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';

import { ERegistrars } from '@feathr/blackbox';
import { Button } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { useFlags, useStore } from '@feathr/extender/state';

import { useDomainStatusPolling } from './DomainDetailPage.hooks';
import DomainDetails from './DomainDetails';
import DomainInfoCard from './DomainInfoCard';
import DomainOverviewCard from './DomainOverviewCard';
import DomainRecords from './DomainRecords';
import DomainRecordsCard from './DomainRecordsCard';

import * as styles from './DomainDetailPage.css';

function DomainDetailPage(): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const flags = useFlags();
  const { Domains } = useStore();
  const { domainId } = useParams<{ domainId: string }>();
  if (!domainId) {
    throw new Error(t('Domain id not found.'));
  }
  const domain = Domains.get(domainId);
  useDomainStatusPolling(domain);

  function handleClickEdit(): void {
    history.push(domain.getItemUrl('edit'));
  }

  if (flags.entriDomainAuth) {
    return (
      <Page loading={domain.isPending} title={domain.displayDomain}>
        <div className={styles.cards}>
          <DomainOverviewCard domain={domain} />
          <DomainInfoCard domain={domain} />
          <DomainRecordsCard domain={domain} format={ERegistrars.default} />
        </div>
      </Page>
    );
  }

  return (
    <Page actions={<Button onClick={handleClickEdit}>{t('Edit')}</Button>} title={domain.name}>
      <DomainDetails domain={domain} />
      <DomainRecords domain={domain} />
    </Page>
  );
}

export default observer(DomainDetailPage);
